import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-24 -md:pt-16" }
const _hoisted_2 = {
  key: 0,
  class: "px-6 py-5"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Dados Cadastrais", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SoftwareHouseDetails = _resolveComponent("SoftwareHouseDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.softwareHouse.data)
            ? (_openBlock(), _createBlock(_component_SoftwareHouseDetails, {
                key: 0,
                data: _ctx.softwareHouse.data,
                mediatorFee: _ctx.mediatorFee,
                softwareHouseCnpj: _ctx.SOFTWARE_HOUSE_CNPJ,
                validateByPass: true,
                class: "shadow-xl",
                isEdit: false
              }, null, 8, ["data", "mediatorFee", "softwareHouseCnpj"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}